import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError, switchMap } from 'rxjs/operators';
import { IEOSData, IEOSDataView } from './entities/eos-data';
import { environment } from 'src/environments/environment';
import { of } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class EosListService {

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router) { }
  
  getEOSData(market: string) {

    const url = `${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/callboard/GetEosLocationData?market=${market}`;

    const loader = this.route.params.pipe(
      switchMap(bl => 
        this.http.get(url)
          .pipe(
            map((b: any) => b),
            catchError(error => of({
              isLoading: false, 
              isLoaded: false,
              isError: true,
              errorMessage: error.error instanceof ErrorEvent ? `an error occurred: ${error.error.message}` : `backend error: ${error.status} - ${error.message}`,
              data: {}
            }))
          )
      ),
      map((d: any) => {

        const ret = d.isError === true ? d : {

          name: d.Name,
          Items: [] = d.Items,
          LastUpdated: d.LastUpdated,
          isNotFound: d.Items.length === 0,

          isLoading: false,
          isLoaded: true,
          isError: false,
          errorMessage: ''
        };
        return ret;
      })
    );
    return loader;
  }
}
